import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
  useRef,
} from "react";
import { useTranslation } from "react-i18next";
import StepContainer from "../stepContainer";
import JobOfInterestSelectionPage from "./jobOfInterestSelectionPage";
import { saveStep } from "../../../services/profileService";
import { useDispatch, useSelector } from "react-redux";
import { profileActions } from "../../../redux/reducers/profileReducer";
import { getUserJobGoals } from "../../../services/profileService";

const JobOfInterestSelection = forwardRef((props, ref) => {
  const { t } = useTranslation();
  const [isJobOfInterestSelection, setIsOfInterestSelection] = useState(false);
  const [existingData, setExistingData] = useState(null);
  const childRef = useRef(); // declare a ref for child component
  const dispatch = useDispatch();

  const existingJobGoals = useSelector((state) => state.profile.jobGoals);

  // On step load
  useEffect(() => {
    props.setProgressValue(50);

    // Check if user has already selected job goals
    if (existingJobGoals.length > 0) {
      setExistingData(existingJobGoals);
      setIsOfInterestSelection(true);
    } 
    else {
      // Make request to check if user has already selected job goals to show them on the page
      getUserJobGoals().then((res) => {
        if (res.data.length > 0) {
          setExistingData(res.data);
          setIsOfInterestSelection(true);
          dispatch(profileActions.setJobGoals(res.data));
        }
      });
    }
  }, []);

  const onStepClose = async (goStepBack = false, stepCompleted = true) => {
    let data = {
      currentStep: 2,
      updatedJobGoals: [],
      isStepCompleted: stepCompleted,
    };
    // Request to save step completion and then navigate to next step
    await saveStep(data);
    if (stepCompleted) {
      if (goStepBack) props.navigateStepBack();
      else props.navigateStepFront();
    }
  };

  useImperativeHandle(ref, () => ({
    onStepClose: (goStepBack, stepCompleted) => {
      if (childRef.current && childRef.current.onStepClose) {
        // Call child's onStepClose, if it's rendered and has onStepClose
        return childRef.current.onStepClose(goStepBack, stepCompleted);
      }

      // Otherwise, fallback to the parent's onStepClose
      return onStepClose(goStepBack, stepCompleted);
    },
  }));

  return (
    <>
      {isJobOfInterestSelection ? (
        <JobOfInterestSelectionPage
          ref={childRef}
          onBack={() => setIsOfInterestSelection(false)}
          navigateStepFront={props.navigateStepFront}
          navigateStepBack={props.navigateStepBack}
          setProgressValue={props.setProgressValue}
          existingData={existingData}
        />
      ) : (
        <StepContainer
          stepTitle={t("profileScreen.jobOfInterestStep.confirmation.title")}
          stepDescription={t(
            "profileScreen.jobOfInterestStep.confirmation.description"
          )}
          onTransparentButtonClick={onStepClose}
          transparentButtonLabel={t("profileScreen.btnNo")}
          onSecondaryButtonClick={() => setIsOfInterestSelection(true)}
          secondaryButtonLabel={t("profileScreen.btnYes")}
        />
      )}
    </>
  );
});

export default JobOfInterestSelection;
